module.exports = __webpack_public_path__ + "img/wechat-img2.a1d469e9.png";